import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { RfqLotService } from '@app/core/rfq-lots/services/rfq-lots.service';
import { RfqLot } from '@app/core/rfq-lots/store/rfq-lots.model';
import { EFeatureFlag } from '@app/feature-toggle-list';

import { SnackBarConfig } from './../../../shared/configs/snackbar.config';

interface IRfqLotFormComponentData {
  rfqId :number;
  quantityOriginal :number;
  purchaseOrderId :number;
}
@Component({
  selector: 'lum-rfq-lot-form',
  templateUrl: './rfq-lot-form.component.html',
  styleUrls: ['./rfq-lot-form.component.scss'],
})
export class RfqLotFormComponent implements OnInit, OnDestroy {
  form :UntypedFormGroup;
  submitting :boolean = false;

  featureFlag = EFeatureFlag;

  private onDestroy$ = new Subject();

  constructor(
    private fb :UntypedFormBuilder,
    private rfqLotService :RfqLotService,
    private snackBar :MatSnackBar,
    public dialogRef :MatDialogRef<RfqLotFormComponent>,
    @Inject(MAT_DIALOG_DATA) private data :IRfqLotFormComponentData,
  ) {}

  ngOnInit() :void {
    this.initForm();
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  onSubmit() :void {
    this.submitting = true;
    const { value } = this.form;
    const { rfqId, quantityOriginal, purchaseOrderId } = this.data;

    const payload = {
      rfqId,
      quantityOriginal,
      purchaseOrderId,
      lotNumber: value.lotNumber,
      productionDate: new Date(value.productionDate),
      expiryDate: new Date(value.expiryDate),
    };

    this.rfqLotService
      .create(payload)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (response :RfqLot) => {
          this.submitting = false;
          this.snackBar.open('Lot created successfully', 'Success', {
            duration: SnackBarConfig.DEFAULT.duration,
          });
          this.dialogRef.close(response);
        },
        error: (response) => {
          this.submitting = false;
          this.snackBar.open(response?.error || 'An error occurred', 'Error');
        },
      });
  }

  private initForm() :void {
    this.form = this.fb.group({
      lotNumber: [''],
      productionDate: [''],
      expiryDate: [''],
    });
  }
}
